import { createGlobalStyle, css, keyframes } from 'styled-components';

import RobotoRegularTtf from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-regular.ttf';
import RobotoRegularWoff from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-regular.woff';
import RobotoRegularWoff2 from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-regular.woff2';
import RobotoRegularEot from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-regular.eot';
import RobotoRegularEotFix from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-regular.eot?#iefix';
import RobotoRegularSvg from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-regular.svg';

import RobotoMediumTtf from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-500.ttf';
import RobotoMediumWoff from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-500.woff';
import RobotoMediumWoff2 from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-500.woff2';
import RobotoMediumEot from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-500.eot';
import RobotoMediumEotFix from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-500.eot?#iefix';
import RobotoMediumSvg from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-500.svg';

import RobotoBoldTtf from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-700.ttf';
import RobotoBoldWoff from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-700.woff';
import RobotoBoldWoff2 from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-700.woff2';
import RobotoBoldEot from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-700.eot';
import RobotoBoldEotFix from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-700.eot?#iefix';
import RobotoBoldSvg from '../../../main-service/ui/shared/assets/fonts/roboto-v27-latin-ext_latin_cyrillic-ext_cyrillic-700.svg';
import { colorsPalette } from './colors-palette';

const fonts = css`
  @font-face {
    font-family: 'SkorozvonRoboto';
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoRegularEot}); /* IE9 Compat Modes */
    src: local('Roboto'), url(${RobotoRegularWoff2}) format('woff2'),
      /* Super Modern Browsers */ url(${RobotoRegularEotFix}) format('embedded-opentype'),
      /* IE6-IE8 */ url(${RobotoRegularWoff}) format('woff'),
      /* Modern Browsers */ url(${RobotoRegularSvg}) format('svg'),
      /* Legacy iOS */ url(${RobotoRegularTtf}) format('truetype'); /* Safari, Android, iOS */
  }
  @font-face {
    font-family: 'SkorozvonRoboto';
    font-style: normal;
    font-weight: 500;
    src: url(${RobotoMediumEot}); /* IE9 Compat Modes */
    src: local('Roboto'), url(${RobotoMediumWoff2}) format('woff2'),
      /* Super Modern Browsers */ url(${RobotoMediumEotFix}) format('embedded-opentype'),
      /* IE6-IE8 */ url(${RobotoMediumWoff}) format('woff'),
      /* Modern Browsers */ url(${RobotoMediumSvg}) format('svg'),
      /* Legacy iOS */ url(${RobotoMediumTtf}) format('truetype'); /* Safari, Android, iOS */
  }

  @font-face {
    font-family: 'SkorozvonRoboto';
    font-style: normal;
    font-weight: 700;
    src: url(${RobotoBoldEot}); /* IE9 Compat Modes */
    src: local('Roboto'), url(${RobotoBoldWoff2}) format('woff2'),
      /* Super Modern Browsers */ url(${RobotoBoldEotFix}) format('embedded-opentype'),
      /* IE6-IE8 */ url(${RobotoBoldWoff}) format('woff'),
      /* Modern Browsers */ url(${RobotoBoldSvg}) format('svg'),
      /* Legacy iOS */ url(${RobotoBoldTtf}) format('truetype'); /* Safari, Android, iOS */
  }
`;

const GRID_SIZES = {
  content: 950,
};

const fadeAnimation = keyframes`
  0% {
    opacity: 0.1;
    transform: rotateX(30deg);
   ;
  }
  50% {
    //transform: rotateX(-20deg);
   ;
  }
  100% {
    opacity: 1;
    transform: rotateX(0deg);
  }
`;

const fadeAnimationCss = css`
  animation: ${fadeAnimation} 300ms ease-out;
`;

const scrollbar = css`
  &::-webkit-scrollbar {
    width: 12px;
    box-sizing: border-box;
    padding-left: 2px;
    position: static;
  }

  &::-webkit-scrollbar-track {
    border-radius: 2px;
    padding-left: 2px;
    //margin: 4px 0;
    border: none;
    position: absolute;
  }

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  &::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none !important;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 9px;
    background-color: ${colorsPalette.gray200};
    border: 4px solid transparent;
    background-clip: content-box;
  }
`;

const GlobalStyle = createGlobalStyle`
  ${fonts}

  .my-node-enter {
    opacity: 0;
  }
  .my-node-enter-active {
    opacity: 1;
    transition: opacity 1200ms;
  }
  .my-node-exit {
    opacity: 1;
  }
  .my-node-exit-active {
    opacity: 0;
    transition: opacity 1200ms;
  }

  
  body,
  html {
    margin: 0;
    padding: 0;
    height: 100%;
    min-width: ${GRID_SIZES.content}px;
    scrollbar-gutter: stable;

    //@supports not (overflow: overlay) {
    //  scrollbar-gutter: stable;
    //}
    
    //@supports (overflow: overlay) {
    //  overflow:overlay;
    //}
    ${scrollbar};
  }

  .ant-select-dropdown .ant-select-item-group {
    font-size: 14px !important;
    font-weight: bold;
  }
  
  .ant-picker-content {
    th, td{
      text-align: center !important;
    }
  }

  .ant-notification .ant-notification-notice-wrapper .notification-popup .ant-notification-notice-close {
      top: 12px !important;
      right: 16px;
  }

  .ant-notification .ant-notification-notice-wrapper .ant-notification-notice {
      padding-bottom: 10px;
  }

  // TODO add rule with :has
  // .ant-drawer{
  //   scrollbar-gutter: stable;
  //
  //   @supports not (overflow: overlay) {
  //     scrollbar-gutter: stable;
  //   }
  //
  //   @supports (overflow: overlay) {
  //     overflow:overlay;
  //   }
  //   ${scrollbar};
  //
  // }
 
  
  #root {
    font-size: 16px;
    font-family: 'Roboto';
  }
  
  *{
    //transition: 0.3s;
  }
  
  ul{
    margin: 0;
  }
  
  h1, h2, h3, h4, h5 {
    font-weight: 500!important;
    margin: 0;
  }
  
  iframe {
    border: none;
  }
  
  div,
  section,
  footer,
  header {
    box-sizing: border-box;
  }
`;

export { GlobalStyle, GRID_SIZES, fonts, scrollbar, fadeAnimationCss, fadeAnimation };
